const BUTTON_LIST = [
  ['undo', 'redo'],
  ['bold', 'underline', 'italic'],
  ['list', 'table'],
  ['link', 'image'],
]

const BUTTON_LIST_SIMPLE = [
  ['undo', 'redo'],
  ['bold', 'italic', 'underline'],
  ['list'],
  ['link', 'image'],
]

const WHITE_LIST_TAGS = 'math-field'

const ALLOWED_TAGS = [
  'p',
  'div',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'span',
  'strong',
  'em',
  'u',
  's',
  'br',
  'ul',
  'ol',
  'li',
  'table',
  'tr',
  'td',
  'th',
  'img',
  'a',
  'blockquote',
  'pre',
  'code',
  'math-field',
]

const MF_SHORTCUTS = {
  sqrt: '\sqrt',
  pi: '\pi',
  theta: '\theta',
  alpha: '\alpha',
  beta: '\beta',
  gamma: '\gamma',
  delta: '\delta',
  epsilon: '\epsilon',
  lambda: '\lambda',
  mu: '\mu',
  sigma: '\sigma',
  phi: '\phi',
  psi: '\psi',
  omega: '\omega',
  Omega: '\Omega',
  Delta: '\Delta',
  Gamma: '\Gamma',
  int: '\int',
  sum: '\sum',
  prod: '\prod',
  lim: '\lim',
  infty: '\infty',
}

const MF_CSS_STYLES =
  'display: inline-block; vertical-align: middle; background-color: #fef3c7; border: 2px solid #f59e0b; border-radius: 6px; padding: 4px 8px; margin: 0 2px; min-width: 100px; font-size: 1.1em; transition: all 0.2s ease; box-shadow: 0 2px 4px rgba(0,0,0,0.1);'

const LATEX_SPAN_CSS_STYLES =
  'display: inline-block; vertical-align: middle; background-color: #f0f9ff; border: 2px solid #0ea5e9; border-radius: 6px; padding: 4px 8px; margin: 0 2px; font-size: 1.1em; cursor: pointer; transition: all 0.2s ease;'

const DEFAULT_STYLE = 'font-size: 14px; line-height: 1.6;'

export {
  BUTTON_LIST,
  BUTTON_LIST_SIMPLE,
  WHITE_LIST_TAGS,
  ALLOWED_TAGS,
  MF_SHORTCUTS,
  MF_CSS_STYLES,
  LATEX_SPAN_CSS_STYLES,
  DEFAULT_STYLE,
}
